import { Link } from "react-router";
import logo from "../assets/images/bruvvi-logo.svg";
import googlePlay from "../assets/images/google-play.png";
import playStore from "../assets/images/play-store.png";
import { routes } from "../routes";
import { footerMenus } from "../common/config/array-config";

const SocialIcon = ({ href, icon, label, bgColor, iconColor }) => (
    <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        className={`w-[60px] h-[60px] ${bgColor} rounded-full flex items-center justify-center shadow-md`}
    >
        <svg className={`w-6 h-6 ${iconColor}`} fill="currentColor" viewBox="0 0 24 24">
            {icon}
        </svg>
    </a>
);

const Footer = () => {
    return (
        <footer>
            <div className="container">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-6 lg:py-[86px] py-[50px]">
                    <div className="md:col-span-2 flex justify-center md:justify-start">
                        <Link to={routes.HOME}>
                            <img className="size-18" src={logo} alt="Bruvvi Logo" />
                        </Link>
                    </div>
                    {footerMenus.map((footerMenu, index) => (
                        <div key={index} className="text-center md:text-left">
                            <h4 className="font-bold text-2xl text-gray-900">{footerMenu.title}</h4>
                            <ul className="mt-4 space-y-2">
                                {footerMenu.items.map((item, idx) => (
                                    <li key={idx}>
                                        <Link to={item.link} className="text-lg text-gray-600 hover:text-gray-900">
                                            {item.menu}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                    <div className="lg:col-span-2 flex flex-col items-center md:items-start text-center md:text-left">
                        <div className="flex space-x-4">
                            <SocialIcon
                                href="#"
                                label="Facebook"
                                bgColor="bg-white"
                                iconColor="text-black"
                                icon={
                                    <path
                                        fillRule="evenodd"
                                        d="M13.135 6H15V3h-1.865a4.147 4.147 0 0 0-4.142 4.142V9H7v3h2v9.938h3V12h2.021l.592-3H12V6.591A.6.6 0 0 1 12.592 6h.543Z"
                                        clipRule="evenodd"
                                    />
                                }
                            />
                            <SocialIcon
                                href="#"
                                label="Instagram"
                                bgColor="bg-primary"
                                iconColor="text-white"
                                icon={
                                    <path
                                        fillRule="evenodd"
                                        d="M3 8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8Zm5-3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H8Zm7.597 2.214a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z"
                                        clipRule="evenodd"
                                    />
                                }
                            />
                            <SocialIcon
                                href="#"
                                label="Twitter"
                                bgColor="bg-white"
                                iconColor="text-black"
                                icon={
                                    <path
                                        fillRule="evenodd"
                                        d="M22 5.892a8.178 8.178 0 0 1-2.355.635 4.074 4.074 0 0 0 1.8-2.235 8.343 8.343 0 0 1-2.605.981A4.13 4.13 0 0 0 15.85 4a4.068 4.068 0 0 0-4.1 4.038c0 .31.035.618.105.919A11.705 11.705 0 0 1 3.4 4.734a4.006 4.006 0 0 0 1.268 5.392 4.165 4.165 0 0 1-1.859-.5v.05A4.057 4.057 0 0 0 6.1 13.635a4.192 4.192 0 0 1-1.856.07 4.108 4.108 0 0 0 3.831 2.807A8.36 8.36 0 0 1 2 18.184 11.732 11.732 0 0 0 8.291 20 11.502 11.502 0 0 0 19.964 8.5c0-.177 0-.349-.012-.523A8.143 8.143 0 0 0 22 5.892Z"
                                        clipRule="evenodd"
                                    />
                                }
                            />
                        </div>
                        <h3 className="text-gray-600 text-xl font-medium mt-6">Discover our app</h3>
                        <div className="flex flex-wrap justify-center md:justify-start lg:space-x-4 space-x-2 mt-4">
                            <img src={googlePlay} alt="Google Play" className="h-12" />
                            <img src={playStore} alt="App Store" className="h-12" />
                        </div>
                    </div>
                </div>
                <p className="text-center text-gray-600 md:text-lg text-md font-medium mb-6">
                    © 2025 Bruvvi, All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
